import "../omega-theme.augmentation";
import { defineTheme, type ThemeDefinition } from "@omega/theme";

import { MOBILE_THEME } from "./mobile.theme";

/**
 * Тёмная тема ТСД (вторая тема реестра). \
 * Look ориентировочный — уточнение у БА (склад / освещение) отдельным TODO.
 */
export const MOBILE_DARK_THEME: ThemeDefinition = defineTheme(
    {
        id: "mobile-dark",
        name: "OMP Mobile Dark",
        scheme: "dark",
        tokens: {
            color: {
                text: {
                    primary: "#F2F2F2",
                    secondary: "#C4CDD5",
                    disabled: "#7A7F86",
                    emphasis: "#FFFFFF",
                    inverse: "#1C1A1F",
                    danger: "#FF8A80",
                },
                background: { default: "#121417" },
                surface: {
                    base: "#1C1F24",
                    hover: "#2A3340",
                    header: "#1A2A3A",
                    modal: "#22262C",
                    disabled: "#3A3F46",
                    selected: "#243447",
                },
                border: {
                    default: "#5C6670",
                    focus: "#6BA3D6",
                    muted: "#3A4048",
                    danger: "#FF8A80",
                    disabled: "#4A5058",
                },
                accent: {
                    main: "#6BA3D6",
                    light: "#8BB8E0",
                    dark: "#3D6F9E",
                    contrastText: "#0D1E4A",
                },
                danger: { main: "#FF8A80" },
                success: { main: "#3DDC97" },
                warning: { main: "#FFB020", contrastText: "#1C1A1F" },
                neutral: { main: "#F2F2F2", contrastText: "#121417" },
                status: {
                    success: "#3DDC97",
                    successSurface: "#1B3A2C",
                    warningSurface: "#3A2E14",
                    error: "#FF8A80",
                    errorSurface: "#3A1F1F",
                    info: "#6BA3D6",
                    infoSurface: "#1A2A3A",
                },
                alert: {
                    success: "#3DDC97",
                },
                skeleton: {
                    base: "#3A4048",
                    highlight: "#4A5058",
                },
                overlay: {
                    backdrop: "rgba(0, 0, 0, 0.65)",
                },
            },
        },
    },
    { base: MOBILE_THEME },
);
